import React from "react";

// Import Ionic
import { IonItem, IonLabel } from "@ionic/react";

// Import Styles
import classNames from "classnames/bind";
import styles from "./CommonFormElements.module.scss";
import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

interface ICommonFormElement {
  label?: string | number;
  isValid?: boolean;
  errorMessage?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  classListItem?: string;
  classListError?: string;
  commonLabelClassName?: string;
  isRequired?: boolean;
}

const CommonFormElement: React.FC<ICommonFormElement> = ({
  label,
  errorMessage,
  classListItem = "",
  classListError = "",
  isValid = true,
  commonLabelClassName,
  isRequired,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <IonItem lines="none" className={cx("commonItem", "ion-no-padding", classListItem)}>
      <IonLabel position={"stacked"} className={cx("commonLabel", commonLabelClassName)}>
        {label} {isRequired && <span className="text-[--ion-color-danger]">*</span>}
      </IonLabel>
      {props.children}
      <span
        className={cx(
          "commonErrorMessage",
          { commonErrorMessage__collapsed: !errorMessage || isValid },
          classListError,
        )}
      >
        {errorMessage ?? t("Required field")}
      </span>
    </IonItem>
  );
};

export default CommonFormElement;
